import { TOKENS_SIZE_DEFAULT } from '../tokens-default.generated.js';
export const UI_FIELD_DEFAULT_OPTION = 'default';
const COMPONENT_ONLY_TOKENS = {
    radius: ['category-icon'],
};
export function sizeTokenOptions(group) {
    const skipped = COMPONENT_ONLY_TOKENS[group] ?? [];
    return Object.entries(TOKENS_SIZE_DEFAULT[group])
        .filter(([name]) => !skipped.includes(name))
        .map(([name, px]) => ({
        value: name,
        label: group === 'radius' && name === 'full' ? 'full (완전 둥글게)' : `${name} (${px}px)`,
    }));
}
export function sizeTokenOptionsWithDefault(group, currentLabel) {
    return [
        { value: UI_FIELD_DEFAULT_OPTION, label: `기본 — ${currentLabel}` },
        ...sizeTokenOptions(group),
    ];
}
export const TITLE_LEVEL_OPTIONS = [
    { value: '1', label: '제목 1 (23px)' },
    { value: '2', label: '제목 2 (19px)' },
    { value: '3', label: '제목 3 (16px)' },
    { value: '4', label: '제목 4 (14px)' },
    { value: '5', label: '제목 5 (12px)' },
];
export const FONT_WEIGHT_OPTIONS = [
    { value: 'normal', label: '보통 (400)' },
    { value: 'medium', label: '중간 (500)' },
    { value: 'semibold', label: '약간 굵게 (600)' },
    { value: 'bold', label: '굵게 (700)' },
];
//# sourceMappingURL=token-options.js.map